﻿import { showErrorNotification } from "@/utils/form-submission-notifications"
import { DefaultModal } from "@components/default-modal"
import { ModalProps } from "@mantine/core"
import {
  CreateActivityCalendarProfile,
  getGetApiWebCalendarGetProfilesQueryKey,
  useCreateActivityWebCalendarProfile,
} from "@/orval/gen"
import { useQueryClient } from "@tanstack/react-query"
import { ActivityCalendarForm } from "./ActivityCalendarForm"
import { useTranslation } from "react-i18next"

const initialValues: CreateActivityCalendarProfile = {
  name: "",
  description: null,
  settings: {
    start: null,
    end: null,
    locationNodeIds: [],
    activityTypeNodeIds: [],
    genreNodeIds: [],
    collectiveNodeIds: [],
    productionIds: [],
  },
  isPublic: false,
}

function ModalContent({ onClose }: Props) {
  const queryClient = useQueryClient()

  const { mutateAsync: createActivityCalendar } =
    useCreateActivityWebCalendarProfile({
      mutation: {
        onSuccess: () => {
          queryClient.invalidateQueries({
            queryKey: getGetApiWebCalendarGetProfilesQueryKey(),
          })
          onClose()
        },
        onError: showErrorNotification,
      },
    })

  const handleSubmit = async (data: CreateActivityCalendarProfile) => {
    await createActivityCalendar({ data })
  }

  return (
    <ActivityCalendarForm
      onClose={onClose}
      handleSubmit={handleSubmit}
      initialValues={initialValues}
    />
  )
}

interface Props extends ModalProps {}

export function CreateActivityCalendarModal(props: Props) {
  const { t } = useTranslation("app_server")
  return (
    <DefaultModal
      title={t("Calendar_Subscriptions_CreateActivityCalendar")}
      {...props}
    >
      <ModalContent {...props} />
    </DefaultModal>
  )
}
